import { useTranslation } from "react-i18next";

import PlusButton from "src/core/assets/images/icons/plus.svg?react";
import { AlertWithIcon } from "src/core/components/custom-ui/alert-with-icon";
import CloseMissionModal from "src/core/components/folder/missions/CloseMissionModal";
import { DeleteMissionModal } from "src/core/components/folder/missions/DeleteMissionModal";
import { missionsColumns } from "src/core/components/folder/missions/missionsColumns";
import { MissionsDataTable } from "src/core/components/folder/missions/MissionsDataTable";
import RenewMissionModal from "src/core/components/folder/missions/RenewMissionModal";
import UpsertMissionModal from "src/core/components/folder/missions/UpsertMissionModal";
import { Button } from "src/core/components/ui/button";
import { Status } from "src/core/constants/folders";
import { useFolderMissions } from "src/core/hooks/folder/useFolderMissions";

export const FolderMissions: React.FC<{ isOnePage?: boolean }> = ({ isOnePage = false }) => {
  const { t } = useTranslation();
  const {
    activeMissions,
    inactiveMissions,
    renewMission,
    deleteMission,
    editMission,
    closeMission,
    states,
    isReadOnly,
    folderFileCreation,
    folderState,
  } = useFolderMissions();

  const activeColumns = missionsColumns({
    isActive: true,
    t,
    renewMission,
    deleteMission,
    editMission,
    isReadOnly,
    closeMission,
    folderFileCreation,
  });
  const inactiveColumns = missionsColumns({
    isActive: false,
    t,
    renewMission,
    deleteMission,
    editMission,
    isReadOnly,
    closeMission,
    folderFileCreation,
  });

  return (
    <div className="folder-missions-wrapper">
      <div className="folder-missions-content">
        {!isOnePage && <div className="folder-tab-banner">{t("folder.missions.tab.title")}</div>}
        {activeMissions.length === 0 && folderState === Status.DRAFT && (
          <AlertWithIcon
            icon="1"
            title=""
            description={t("folder.missions.data.emptyDescription")}
            variant="destructive"
            className="mx-0"
          />
        )}
        {activeMissions.length > 0 && (
          <MissionsDataTable
            columns={activeColumns}
            data={activeMissions}
            className={`${inactiveMissions.length > 0 ? "mb-10" : "last"}`}
          />
        )}

        {inactiveMissions.length > 0 && (
          <MissionsDataTable columns={inactiveColumns} data={inactiveMissions} className="last" />
        )}
      </div>

      {!isReadOnly && (
        <Button
          className="folder-missions-add-button"
          variant="default"
          onClick={() => states.setOpenUpsertModal(true)}
        >
          <PlusButton />
          {t("folder.missions.addMission")}
        </Button>
      )}

      <UpsertMissionModal
        open={states.openUpsertModal}
        setOpen={states.setOpenUpsertModal}
        mission={states.missionToEdit}
        setMissionToEdit={states.setMissionToEdit}
      />

      <RenewMissionModal
        open={states.openRenewModal}
        setOpen={states.setOpenRenewModal}
        mission={states.missionToEdit}
        setMissionToEdit={states.setMissionToEdit}
      />

      <DeleteMissionModal
        open={states.openDeleteModal}
        setOpen={states.setOpenDeleteModal}
        mission={states.missionToEdit}
        setMissionToEdit={states.setMissionToEdit}
      />

      <CloseMissionModal
        open={states.openCloseModal}
        setOpen={states.setOpenCloseModal}
        mission={states.missionToEdit}
        setMissionToEdit={states.setMissionToEdit}
      />
    </div>
  );
};
